import { cva } from 'class-variance-authority'

export const titleRootVariant = cva(
  'flex items-center gap-2 font-bold text-black',
  {
    variants: {
      size: {
        small: 'text-[13px]',
        default: 'text-base',
        large: 'text-lg'
      }
    }
  }
)

export const titleLineVariant = cva('b w-[3px] rounded-[3px]', {
  variants: {
    size: {
      small: 'h-3.5',
      default: 'h-4',
      large: 'h-[18px]'
    },
    lineColor: {
      primary: 'bg-primary',
      gray: 'bg-gray-1'
    }
  }
})
